import React from "react";
import { labels } from "../../../localization/labels";
import PageComponent from "../../domain/page/PageComponent";
import Share from "./Share";

class ShareContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.messageHandler = props.messageHandler;
  }
  onShareViaWhatsapp = () => {
    window.location = "whatsapp://send?text=" + window.location.href;
  };

  onShareViaViber = () => {
    window.location = "viber://forward?text=" + window.location.href;
  };

  onShareViaMail = () => {
    const subject = this.props.mailSubject
      ? this.props.mailSubject
      : labels.shareViaMailSubject;

    window.location =
      "mailto:?body=" + window.location.href + "&subject=" + subject;
  };

  onCopyUrl = () => {
    let dummy = document.createElement("input"),
      text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.messageHandler.handleSuccess({ text: labels.urlCopied });
  };

  render() {
    return (
      <Share
        {...this.props}
        onShareViaWhatsapp={this.onShareViaWhatsapp}
        onShareViaViber={this.onShareViaViber}
        onShareViaMail={this.onShareViaMail}
        onCopyUrl={this.onCopyUrl}
      />
    );
  }
}

export default ShareContainer;
